<template>
  <div class="wholeContext">
    <div class="appContext">
      <div class="container">
        <div class="area_wrap">
          <div class="error_wrap">
            <div class="imgWrap">
              <img src="@/assets/images/error.svg">
            </div>
            <div class="text_wrap">
              <div class="largeText">
                <h1>죄송합니다</h1>
              </div>
              <p>요청하신 페이지를 찾을 수 없거나 </p>
              <p>예기치 못한 오류가 발생하였습니다. </p>
              <p>보다 정확하고 편리한 서비스를 제공할 수 있도록 </p>
              <p>최선을 다하겠습니다. </p>
            </div>
          </div>
        </div>
      </div>
      <div class="btnWrap visible">
        <router-link to="/">
          <button type="button" class="callTerms">메인으로</button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import EventBus from '@/utils/bus'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single'
      },
      transDate: {
        headerName: '공지사항',
        prevUrl: '/'
      },
      setCount: false
    }
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
  },
  mounted () {
    EventBus.$emit('pageAccess', true)
  },
  computed: {
    ...mapGetters([

    ]),
    ...mapState([

    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP'
    ]),
    ...mapActions([

    ]),
    callPrev () {
      if (this.setCount) {
        this.$router.push('/')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    },
    goReturn () {
      this.$router.go(-1)
    }
  },
  components: {
  },
  beforeDestroy () {
    this.SET_POPUP(false)
    this.setCount = false
    EventBus.$off('pageAccess')
  }
}
</script>

<style lang="scss" scoped>
</style>
